import React, { useEffect, useState } from "react";

/**
 * Global loader for the whole website.
 * Shows GPS logo with a smooth animation until the app is ready.
 */
export default function GlobalLoader({ onLoadComplete }) {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Minimum time to show loader (so user sees the branding)
    const minDisplayTime = 1500;
    const startTime = Date.now();

    const timer = setTimeout(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minDisplayTime - elapsed);
      setTimeout(() => {
        setFadeOut(true);
        onLoadComplete?.();
        setTimeout(() => setVisible(false), 400);
      }, remaining);
    }, 100);

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  if (!visible) return null;

  return (
    <div
      className="global-loader"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 50%, #e0f2fe 100%)",
        transition: "opacity 0.4s ease-out",
        opacity: fadeOut ? 0 : 1,
        pointerEvents: fadeOut ? "none" : "auto",
      }}
      aria-live="polite"
      aria-label="Loading application"
    >
      <style>{`
        @keyframes global-loader-pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.85; transform: scale(1.02); }
        }
        @keyframes global-loader-ring {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes global-loader-fade-out {
          to { opacity: 0; }
        }
        .global-loader .loader-logo {
          animation: global-loader-pulse 1.5s ease-in-out infinite;
        }
        .global-loader .loader-ring {
          animation: global-loader-ring 1.2s linear infinite;
        }
      `}</style>

      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "24px",
        }}
      >
        {/* Optional: spinning ring around logo */}
        <div
          className="loader-ring"
          style={{
            position: "absolute",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "3px solid transparent",
            borderTopColor: "#006e82",
            borderRightColor: "#b3eaf4",
            borderBottomColor: "#39b2b4",
            borderLeftColor: "#ccf1f7",
            top: "111%",
          }}
        />

        {/* GPS Logo */}
        <div
          className="loader-logo"
          style={{
            position: "relative",
            zIndex: 1,
            width: "120px",
            maxWidth: "80vw",
          }}
        >
          <img
            src="/images/gpslogo.png"
            alt="GPS Logo"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </div>

        {/* Loading text */}
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: 600,
            color: "#006e82",
            letterSpacing: "0.05em",
          }}
        >
          Loading...
        </p>

        {/* Progress bar */}
        {/* <div
          style={{
            width: "120px",
            height: "4px",
            borderRadius: "4px",
            background: "#e2e8f0",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "40%",
              background: "linear-gradient(90deg, #006e82, #39b2b4)",
              borderRadius: "4px",
              animation: "global-loader-pulse 1s ease-in-out infinite",
            }}
          />
        </div> */}
      </div>
    </div>
  );
}
